<template>
    <div class="row">
        <div class="card">
            <div class="card-header">
                <h2>Lista de Participantes</h2>
            </div>
            <div class="card-body">
                <div class="mt-3 mb-16">
                    <tabela-sindicato-evento />
                </div>
                <div class="mt-5 mb-3 mt-16">
                    <tabela-participante-evento/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TabelaParticipanteEvento from './tabela-participantes-evento'
import TabelaSindicatoEvento from './tabela-sindicatos-evento'
export default {
    name: 'listar-participantes-evento',

    components: { TabelaParticipanteEvento, TabelaSindicatoEvento }
}
</script>

